var App = App || {};

App.CommunityGallery = (function ($) {
    "use strict";

    var carouselLgHeight = "850px",
        carouselMdHeight = "470px",
        carouselSmHeight = "355px",
        carouselXsHeight = "240px",
        carouselSpeed = 0.5;
    function init() {
        const CommunityGallery = $(".component.component-communitygallery");
        if (CommunityGallery.length) {
            CommunityGallery.each(function () {
                CommunityGalleryCarousels(CommunityGallery);
            });
        }
    }

    function CommunityGalleryCarousels(CommunityGallery) {

        const leftCarousel = CommunityGallery.find(".cardcol.left");
        const centerCarousel = CommunityGallery.find(".cardcol.center");
        const rightCarousel = CommunityGallery.find(".cardcol.right");
        const pauseBtn = CommunityGallery.find(".pause-btn");
        var rightCarouselCount = rightCarousel.attr("data-count");

        const leftSplide = new Splide(leftCarousel[0], {
            pagination: false,
            height: carouselLgHeight,
            type: 'loop',
            arrows: false,
            autoScroll: {
                pauseOnHover: false,
                speed: carouselSpeed,
            },
            rewind: false,
            direction: 'ttb',
            fixedHeight: "fit-content",
            gap: "30px",
            useIndex: true,
            drag: false,
            role: 'group',
            breakpoints: {
                991: {
                    height: carouselMdHeight,
                    gap: "20px",
                },
                767: {
                    height: carouselSmHeight,
                    gap: "10px",
                },
                575: {
                    height: carouselXsHeight,
                    gap: "10px",
                },
            }
        });
        const centerSplide = new Splide(centerCarousel[0], {
            pagination: false,
            height: carouselLgHeight,
            type: 'loop',
            arrows: false,
            autoScroll: {
                pauseOnHover: false,
                speed: carouselSpeed,
            },
            rewind: false,
            direction: 'ttb',
            fixedHeight: "fit-content",
            gap: "30px",
            useIndex: true,
            drag: false,
            role: 'group',
            breakpoints: {
                991: {
                    height: carouselMdHeight,
                    gap: "20px",
                },
                767: {
                    height: carouselSmHeight,
                    gap: "10px",
                },
                575: {
                    height: carouselXsHeight,
                    gap: "10px",
                },
            }
        });
        const rightSplide = new Splide(rightCarousel[0], {
            pagination: false,
            height: carouselLgHeight,
            type: 'loop',
            arrows: false,
            autoScroll: {
                pauseOnHover: false,
                speed: carouselSpeed,
            },
            rewind: false,
            direction: 'ttb',
            fixedHeight: "fit-content",
            start: (rightCarouselCount / 2),
            gap: "30px",
            useIndex: true,
            drag: false,
            role: 'group',
        });

        pauseBtn.on("click", function () {
            if (leftSplide.Components.AutoScroll.isPaused() && centerSplide.Components.AutoScroll.isPaused() && rightSplide.Components.AutoScroll.isPaused()) {
                leftSplide.Components.AutoScroll.play();
                centerSplide.Components.AutoScroll.play();
                rightSplide.Components.AutoScroll.play();
                $(this).find(".fa.fa-play").removeClass("fa-play").addClass("fa-pause");
            } else {
                leftSplide.Components.AutoScroll.pause();
                centerSplide.Components.AutoScroll.pause();
                rightSplide.Components.AutoScroll.pause();
                $(this).find(".fa.fa-pause").removeClass("fa-pause").addClass("fa-play");
            }
        });

        leftSplide.mount(window.splide.Extensions);
        centerSplide.mount(window.splide.Extensions);
        rightSplide.mount(window.splide.Extensions);
    }
    return {
        init: init
    };

})(jQuery);

$(function () {
    App.CommunityGallery.init();
});